import { render, staticRenderFns } from "./ForgotPasswordForm.vue?vue&type=template&id=6eeacb30&scoped=true"
import script from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordForm.vue?vue&type=style&index=0&id=6eeacb30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eeacb30",
  null
  
)

export default component.exports